const isAllowed = props => {
  const authData = JSON.parse(localStorage.getItem('auth'));

  return (
    authData === null ||
    authData.permissions === undefined ||
    authData.permissions[props.action] === undefined ||
    authData.permissions[props.action] === 1
  );
};
export default isAllowed;
